import React, { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { sendPasswordResetEmail } from "../../server/server";
import { useNavigate } from "react-router";
import { createTheme, ThemeProvider } from "@mui/material";
import { ReactComponent as Grb } from "../../assets/svg/srbija-grb.svg";

const theme = createTheme({
  typography: { fontFamily: "Fira Sans Condensed" },
});

const PasswordReset = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [fieldErrors, setFieldErrors] = useState<{
    email?: string;
  }>({});
  const [fieldTouched, setFieldTouched] = useState<{
    email?: boolean;
  }>({});

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const email = data.get("email") as string;
    const errors: { email?: string } = {};

    if (!email) {
      errors.email = "Обавезно поље";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Неисправна е-маил адреса";
    }

    setFieldTouched({ email: true });
    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) {
      setErrorMessage("");
      setSuccessMessage("");
      return;
    }

    const resp = await sendPasswordResetEmail(email);
    if (resp?.status === 201) {
      setSuccessMessage(
        "Е-маил за ресетовање лозинке је послат на вашу адресу.",
      );
      setErrorMessage("");
    } else {
      setErrorMessage(resp?.data?.message || "Грешка при слању е-маила");
      setSuccessMessage("");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
          }}
        >
          <div>
            <div className="flex flex-col justify-between gap-2 ml-3 items-center">
              <Grb />
              <div className="flex flex-col mt-2 items-center">
                <span className="font-medium text-xl">Република Србија</span>
                <span className="text-xl">
                  Министарство за европске интеграције
                </span>
              </div>
            </div>

            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 2 }}
              className="flex flex-col items-center"
            >
              <label htmlFor="email">
                Унесите е-маил адресу везану за ваш налог
              </label>
              <TextField
                margin="normal"
                fullWidth
                id="email"
                label="Е-маил адреса"
                name="email"
                autoComplete="email"
                autoFocus
                error={Boolean(fieldErrors.email)}
                helperText={fieldErrors.email}
                onBlur={() =>
                  setFieldTouched((prev) => ({ ...prev, email: true }))
                }
                FormHelperTextProps={{ style: { color: "red" } }}
                InputProps={{
                  style: fieldErrors.email ? { borderColor: "red" } : undefined,
                }}
                inputProps={{
                  style: fieldErrors.email ? { color: "red" } : undefined,
                  placeholder: fieldErrors.email ? "Обавезно поље" : undefined,
                }}
              />
              {errorMessage && (
                <Typography component="p" sx={{ color: "error.main" }}>
                  {errorMessage}
                </Typography>
              )}
              {successMessage && (
                <Typography component="p" sx={{ color: "success.main" }}>
                  {successMessage}
                </Typography>
              )}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, backgroundColor: "#0F2765" }}
              >
                Пошаљи
              </Button>
              <div
                className="text-center mt-1 text-[18px] cursor-pointer text-darkBlue underline"
                onClick={() => navigate("/login")}
              >
                Назад на пријаву
              </div>
            </Box>
          </div>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default PasswordReset;
